import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '../database.types';

let supabaseInstance: SupabaseClient<Database> | null = null;

/**
 * Configuração do cliente Supabase
 */
export interface SupabaseConfig {
  url: string;
  anonKey: string;
}

/**
 * Inicializa e retorna o cliente Supabase singleton
 */
export function initSupabaseClient(config: SupabaseConfig): SupabaseClient<Database> {
  if (supabaseInstance) return supabaseInstance;

  if (!config.url || !config.anonKey) {
    throw new Error('Supabase URL and anon key are required');
  }

  supabaseInstance = createClient<Database>(config.url, config.anonKey, {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });

  return supabaseInstance;
}

/**
 * Retorna o cliente Supabase (deve ser inicializado primeiro)
 */
export function getSupabaseClient(): SupabaseClient<Database> {
  if (!supabaseInstance) {
    throw new Error('Supabase client not initialized. Call initSupabaseClient first.');
  }
  return supabaseInstance;
}

/**
 * Reseta o cliente (útil para testes)
 */
export function resetSupabaseClient(): void {
  supabaseInstance = null;
}

export type { Database };
